// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"712":"84225078","952":"304e3484"}[chunkId] + ".chunk.js");